import React, { useState } from "react";
import Sidebar from "../../component/Sidebar";
import Topbar from "../../component/Topbar";
import { 
  FiDollarSign, 
  FiClock, 
  FiCheckCircle, 
  FiArrowUpRight, 
  FiSearch, 
  FiDownload, 
  FiExternalLink 
} from "react-icons/fi";

function PaymentSummary() {
  // 10 Dummy Payout Transactions for a Vendor
  const dummyTransactions = [
    { id: "PAY-99281", date: "2024-01-14", amount: "₹14,500.00", fee: "₹450", net: "₹14,050.00", status: "completed", bank: "HDFC Bank ****210" },
    { id: "PAY-99275", date: "2024-01-12", amount: "₹8,200.00", fee: "₹210", net: "₹7,990.00", status: "completed", bank: "HDFC Bank ****210" },
    { id: "PAY-99260", date: "2024-01-10", amount: "₹22,000.00", fee: "₹800", net: "₹21,200.00", status: "pending", bank: "HDFC Bank ****210" },
    { id: "PAY-99242", date: "2024-01-08", amount: "₹5,150.00", fee: "₹150", net: "₹5,000.00", status: "completed", bank: "HDFC Bank ****210" },
    { id: "PAY-99211", date: "2024-01-05", amount: "₹45,000.00", fee: "₹1,200", net: "₹43,800.00", status: "failed", bank: "HDFC Bank ****210" },
    { id: "PAY-99190", date: "2024-01-02", amount: "₹12,300.00", fee: "₹300", net: "₹12,000.00", status: "completed", bank: "HDFC Bank ****210" },
    { id: "PAY-99182", date: "2023-12-30", amount: "₹18,000.00", fee: "₹500", net: "₹17,500.00", status: "completed", bank: "HDFC Bank ****210" },
    { id: "PAY-99150", date: "2023-12-28", amount: "₹9,500.00", fee: "₹250", net: "₹9,250.00", status: "completed", bank: "HDFC Bank ****210" },
    { id: "PAY-99120", date: "2023-12-25", amount: "₹30,000.00", fee: "₹900", net: "₹29,100.00", status: "completed", bank: "HDFC Bank ****210" },
    { id: "PAY-99101", date: "2023-12-20", amount: "₹6,000.00", fee: "₹180", net: "₹5,820.00", status: "completed", bank: "HDFC Bank ****210" },
  ];

  const [transactions] = useState(dummyTransactions);

  const stats = [
    { label: "Total Settled", value: "₹2,14,550", icon: <FiCheckCircle />, color: "green" },
    { label: "Next Payout", value: "₹21,200", icon: <FiClock />, color: "orange" },
    { label: "Avg. Daily Sales", value: "₹4,500", icon: <FiDollarSign />, color: "blue" },
  ];

  return (
    <>
      <Topbar />
      <Sidebar />

      <main className="main-wrapper vendor-payout-panel">
        <div className="main-content">
          
          {/* Header Section */}
          <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-4 gap-3">
            <div>
              <h4 className="fw-bold mb-0">Payments & Payouts</h4>
              <p className="text-muted small mb-0">Manage your earnings, fees, and bank settlements</p>
            </div>
            <div className="d-flex gap-2">
              <button className="btn btn-outline-dark d-flex align-items-center gap-2 shadow-sm bg-white">
                <FiDownload /> Tax Report
              </button>
              <button className="btn btn-primary d-flex align-items-center gap-2 shadow-sm">
                Request Instant Payout <FiArrowUpRight />
              </button>
            </div>
          </div>

          {/* KPI Cards */}
          <div className="row g-3 mb-4">
            {stats.map((stat, idx) => (
              <div className="col-12 col-md-4" key={idx}>
                <div className="stat-card shadow-sm border-0 card h-100">
                  <div className="card-body">
                    <div className="d-flex justify-content-between mb-3">
                        <div className={`icon-circle ${stat.color}`}>{stat.icon}</div>
                        <span className="text-success small fw-bold">+12%</span>
                    </div>
                    <p className="text-muted small fw-bold text-uppercase mb-1">{stat.label}</p>
                    <h3 className="fw-bold mb-0">{stat.value}</h3>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Payout History Table */}
          <div className="card border-0 shadow-sm rounded-4 overflow-hidden">
            <div className="card-header bg-white py-3 border-bottom d-flex flex-wrap justify-content-between align-items-center gap-3">
              <h6 className="mb-0 fw-bold">Payout History</h6>
              <div className="d-flex gap-2">
                <div className="search-box">
                    <FiSearch className="search-icon" />
                    <input type="text" placeholder="Search Transaction ID..." className="form-control form-control-sm" />
                </div>
              </div>
            </div>
            <div className="card-body p-0">
              <div className="table-responsive">
                <table className="table table-hover align-middle mb-0 payout-table">
                  <thead>
                    <tr>
                      <th>TRANSACTION ID</th>
                      <th>SETTLEMENT DATE</th>
                      <th>GROSS AMOUNT</th>
                      <th>MARKETPLACE FEES</th>
                      <th>NET PAYOUT</th>
                      <th>STATUS</th>
                      <th>DETAILS</th>
                    </tr>
                  </thead>
                  <tbody>
                    {transactions.map((trx, i) => (
                      <tr key={i}>
                        <td className="fw-medium text-dark">{trx.id}</td>
                        <td className="text-muted">
                          {new Date(trx.date).toLocaleDateString("en-GB", {
                            day: 'numeric', month: 'short', year: 'numeric'
                          })}
                        </td>
                        <td>{trx.amount}</td>
                        <td className="text-danger">-{trx.fee}</td>
                        <td className="fw-bold text-dark">{trx.net}</td>
                        <td>
                          <span className={`status-pill ${trx.status}`}>
                            {trx.status}
                          </span>
                        </td>
                        <td>
                          <button className="btn btn-link btn-sm text-decoration-none p-0">
                            <FiExternalLink />
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="card-footer bg-white border-top py-3">
                <div className="d-flex justify-content-between align-items-center">
                    <span className="small text-muted">Showing last 10 transactions</span>
                    <nav>
                        <ul className="pagination pagination-sm mb-0">
                            <li className="page-item disabled"><span className="page-link">Prev</span></li>
                            <li className="page-item active"><span className="page-link">1</span></li>
                            <li className="page-item"><span className="page-link">Next</span></li>
                        </ul>
                    </nav>
                </div>
            </div>
          </div>
        </div>
      </main>

      <style>{`
        .vendor-payout-panel {
          background-color: #f3f4f6;
          min-height: 100vh;
          padding: 2rem;
          font-family: 'Inter', sans-serif;
        }

        /* Stat Cards */
        .stat-card {
          border-radius: 16px;
          transition: all 0.3s ease;
        }
        .stat-card:hover {
          transform: translateY(-4px);
        }
        .icon-circle {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 1.2rem;
        }
        .icon-circle.green { background: #dcfce7; color: #16a34a; }
        .icon-circle.orange { background: #ffedd5; color: #ea580c; }
        .icon-circle.blue { background: #dbeafe; color: #2563eb; }

        /* Search Box */
        .search-box {
            position: relative;
        }
        .search-icon {
            position: absolute;
            left: 10px;
            top: 50%;
            transform: translateY(-50%);
            color: #94a3b8;
        }
        .search-box input {
            padding-left: 35px;
            border-radius: 8px;
            width: 220px;
        }

        /* Table Styling */
        .payout-table thead th {
          background-color: #f8fafc;
          color: #64748b;
          font-size: 0.75rem;
          font-weight: 700;
          text-transform: uppercase;
          letter-spacing: 0.025em;
          padding: 1rem;
          border-bottom: 1px solid #e2e8f0;
        }

        .payout-table tbody td {
          padding: 1rem;
          font-size: 0.875rem;
          color: #475569;
          border-bottom: 1px solid #f1f5f9;
        }

        /* Status Pills */
        .status-pill {
          padding: 4px 12px;
          border-radius: 9999px;
          font-size: 0.75rem;
          font-weight: 600;
          text-transform: capitalize;
        }
        .status-pill.completed { background: #dcfce7; color: #15803d; }
        .status-pill.pending { background: #fef3c7; color: #b45309; }
        .status-pill.failed { background: #fee2e2; color: #b91c1c; }

        /* Buttons */
        .btn-primary {
          background-color: #232f3e;
          border: none;
          font-weight: 500;
          border-radius: 8px;
        }
        .btn-primary:hover {
          background-color: #131921;
        }
        
        .page-link {
            color: #232f3e;
            border-radius: 6px !important;
            margin: 0 2px;
        }
        .page-item.active .page-link {
            background-color: #232f3e;
            border-color: #232f3e;
        }
      `}</style>
    </>
  );
}

export default PaymentSummary;